module.exports = __webpack_public_path__ + "7d088296/img/settings-icon.121d9519.svg";